(function () {
  'use strict';

  function toMasterUrl(url) {
    if (!url || url === 'none') return '';
    var clean = url.replace(/^url\(["']?/, '').replace(/["']?\)$/, '').split('?')[0];
    return clean
      .replace(/_(?:compact|small|medium|large|grande|1024x1024|50x50|50x|300x300|600x|120x|800x|1024x)(?=\.[a-z]+$)/i, '')
      .replace(/\/(?:compact|small|medium|large|grande|1024x1024|50x50|120x)(?=\/)/, '/');
  }

  function openZoom(src) {
    var url = toMasterUrl(src);
    if (!url) return;

    if (url.indexOf('//') === 0) {
      url = window.location.protocol + url;
    }

    function tryOpen(attempts) {
      var $jq = window.jQuery;

      if ($jq && $jq.fancybox) {
        $jq.fancybox.open([{ src: url, type: 'image' }]);
        return;
      }

      if (attempts < 30) {
        window.setTimeout(function () {
          tryOpen(attempts + 1);
        }, 100);
        return;
      }

      window.open(url, '_blank');
    }

    tryOpen(0);
  }

  function bindSwatchZoom() {
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest ? event.target.closest('.swatch-zoom-btn') : null;

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var zoomUrl = button.getAttribute('data-zoom-url');

      if (!zoomUrl) {
        var media = button.closest('.swatch-variant-media');
        var bgEl = media && media.querySelector('.bgImg');

        if (bgEl) {
          var bgImage = window.getComputedStyle(bgEl).backgroundImage;
          zoomUrl = bgImage && bgImage !== 'none' ? bgImage : '';
        }
      }

      openZoom(zoomUrl);
    }, true);
  }

  window.productDetailSwatchZoom = {
    openZoom: openZoom,
    toMasterUrl: toMasterUrl
  };

  var mobileLayoutBound = false;

  function getMobileLayoutElements() {
    var top = document.querySelector('.template-product .product_top');

    if (!top) {
      return null;
    }

    var photos = top.querySelector(':scope > .product-photos');
    var gallery = photos && photos.querySelector(':scope > .product-img-box');
    var shop = top.querySelector(':scope > .product-shop') || (photos && photos.querySelector(':scope > .product-shop'));

    if (!photos || !shop || !gallery) {
      return null;
    }

    return {
      photos: photos,
      shop: shop,
      gallery: gallery
    };
  }

  function refreshMobileGallery(gallery) {
    if (!window.jQuery || !gallery) {
      return;
    }

    var $gallery = window.jQuery(gallery);
    var $sliderFor = $gallery.find('.slider-for');
    var $sliderNav = $gallery.find('.slider-nav');

    if ($sliderFor.hasClass('slick-initialized')) {
      $sliderFor.slick('setPosition');
    }

    if ($sliderNav.hasClass('slick-initialized')) {
      $sliderNav.slick('setPosition');
    }
  }

  function applyMobileProductLayout() {
    var mq = window.matchMedia('(max-width: 1199px)');
    var elements = getMobileLayoutElements();

    if (!elements) {
      return;
    }

    if (mq.matches) {
      if (elements.gallery.nextElementSibling !== elements.shop) {
        elements.gallery.insertAdjacentElement('afterend', elements.shop);
      }
    } else if (elements.photos.nextElementSibling !== elements.shop) {
      elements.photos.insertAdjacentElement('afterend', elements.shop);
    }

    window.setTimeout(function () {
      refreshMobileGallery(elements.gallery);
    }, 50);
  }

  function initMobileProductLayout() {
    var mq = window.matchMedia('(max-width: 1199px)');

    applyMobileProductLayout();

    if (mobileLayoutBound) {
      return;
    }

    mobileLayoutBound = true;

    if (mq.addEventListener) {
      mq.addEventListener('change', applyMobileProductLayout);
    } else if (mq.addListener) {
      mq.addListener(applyMobileProductLayout);
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(window.mobileProductLayoutTimer);
      window.mobileProductLayoutTimer = window.setTimeout(applyMobileProductLayout, 150);
    });

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(applyMobileProductLayout, 200);
    });
  }

  function collapseShippingReturnsOnMobile() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    document.querySelectorAll('.product-detail-shipping-accordion').forEach(function (accordion) {
      var link = accordion.querySelector('.product-detail-shipping-accordion__item [data-tapTop]');
      var targetSelector = link && link.getAttribute('data-target');
      var content = targetSelector ? document.querySelector(targetSelector) : null;

      if (link) {
        link.classList.remove('active');
      }

      if (content) {
        content.classList.remove('active');
      }

      accordion.removeAttribute('data-mobile-start-collapsed');
    });
  }

  function bindProductDetailAccordions() {
    if (window.__dodoProductAccordionBound) {
      return;
    }
    window.__dodoProductAccordionBound = true;

    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('.product-detail-shipping-accordion [data-tapTop]') : null;
      var accordion = link && link.closest('.product-detail-shipping-accordion');

      if (accordion && accordion.hasAttribute('data-mobile-start-collapsed')) {
        accordion.removeAttribute('data-mobile-start-collapsed');

        if (window.matchMedia('(max-width: 767px)').matches) {
          var pendingTarget = document.querySelector(link.getAttribute('data-target'));
          link.classList.remove('active');
          if (pendingTarget) {
            pendingTarget.classList.remove('active');
          }
        }
      }
    }, true);

    document.addEventListener('click', function (event) {
      var link = event.target.closest(
        '.product-detail-shipping-accordion [data-tapTop], ' +
        '.product-detail-description-accordion [data-tapTop], ' +
        '.product-detail-shipping-accordion [data-description-toggle], ' +
        '.product-detail-description-accordion [data-description-toggle]'
      );

      if (!link) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var targetSelector = link.getAttribute('data-target');

      if (!targetSelector) {
        return;
      }

      var target = document.querySelector(targetSelector);

      if (!target) {
        return;
      }

      var accordion = link.closest('.product-detail-shipping-accordion, .product-detail-description-accordion');
      var isActive = link.classList.contains('active');

      if (accordion && accordion.classList.contains('product-detail-shipping-accordion') && !isActive) {
        accordion.querySelectorAll('[data-tapTop], [data-description-toggle]').forEach(function (otherLink) {
          if (otherLink === link) {
            return;
          }

          otherLink.classList.remove('active');

          var otherSelector = otherLink.getAttribute('data-target');
          var otherTarget = otherSelector ? document.querySelector(otherSelector) : null;

          if (otherTarget) {
            otherTarget.classList.remove('active');
          }
        });
      }

      link.classList.toggle('active');
      target.classList.toggle('active');
    });
  }

  window.productDetailMobileLayout = {
    apply: applyMobileProductLayout,
    init: initMobileProductLayout
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindSwatchZoom();
      bindProductDetailAccordions();
      collapseShippingReturnsOnMobile();
      window.setTimeout(initMobileProductLayout, 300);
    });
  } else {
    bindSwatchZoom();
    bindProductDetailAccordions();
    collapseShippingReturnsOnMobile();
    window.setTimeout(initMobileProductLayout, 300);
  }

  document.addEventListener('shopify:section:load', function () {
    bindProductDetailAccordions();
    collapseShippingReturnsOnMobile();
  });
})();

(function bootProductDetailEnhancements() {
  if (!window.jQuery) {
    window.setTimeout(bootProductDetailEnhancements, 50);
    return;
  }

  (function ($) {
    'use strict';

    var toMasterUrl = window.productDetailSwatchZoom
      ? window.productDetailSwatchZoom.toMasterUrl
      : function (url) { return url || ''; };

    var openZoom = window.productDetailSwatchZoom
      ? window.productDetailSwatchZoom.openZoom
      : function (url) { window.open(url, '_blank'); };

    function normalizeImageUrl(url) {
      return toMasterUrl(url).replace(/\.jpg\.jpg$/, '.jpg');
    }

    function syncFancyboxHref(imgSrc) {
      if (!imgSrc) return;

      var master = toMasterUrl(imgSrc);
      var $link = $('.slider-for .slick-active a.fancybox');

      if (!$link.length) {
        $link = $('.slider-for .thumb:not(.slick-cloned) a.fancybox').first();
      }

      if ($link.length) {
        $link.attr('href', master);
      }
    }

    function findSlideIndexByImageId($slider, imageId) {
      if (!imageId || !$slider.length) return -1;

      var index = -1;
      $slider.find('.slick-slide:not(.slick-cloned)').each(function (i) {
        var $img = $(this).find('img[id^="product-featured-image"]');
        if ($img.length && String($img.attr('id')) === 'product-featured-image-' + imageId) {
          index = i;
          return false;
        }
      });
      return index;
    }

    function findSlideIndexBySrc($slider, targetSrc) {
      if (!targetSrc || !$slider.length) return -1;

      var normalizedTarget = normalizeImageUrl(targetSrc);
      var index = -1;

      $slider.find('.slick-slide:not(.slick-cloned)').each(function (i) {
        var $img = $(this).find('img[id^="product-featured-image"]');
        if (!$img.length) return;

        var src = normalizeImageUrl($img.attr('src') || $img.attr('data-src') || '');
        if (src && src === normalizedTarget) {
          index = i;
          return false;
        }
      });

      return index;
    }

    function goToSlide($sliderFor, $sliderNav, slideIndex) {
      if (slideIndex < 0) return false;

      if ($sliderFor.hasClass('slick-initialized')) {
        $sliderFor.slick('slickGoTo', slideIndex, true);
      }

      if ($sliderNav.length && $sliderNav.hasClass('slick-initialized')) {
        $sliderNav.slick('slickGoTo', slideIndex, true);
      }

      return true;
    }

    function syncVariantMainImage(variant) {
      if (!variant || !variant.featured_image) return;

      var featuredImage = variant.featured_image;
      var $productPhotos = $('[data-more-view-product]');
      var $sliderFor = $productPhotos.find('.slider-for');
      var $sliderNav = $productPhotos.find('.slider-nav');
      var slideIndex = findSlideIndexByImageId($sliderFor, featuredImage.id);

      if (slideIndex < 0) {
        slideIndex = findSlideIndexBySrc($sliderFor, featuredImage.src);
      }

      if (slideIndex >= 0) {
        goToSlide($sliderFor, $sliderNav, slideIndex);
      } else {
        var $navMatch = $sliderNav.find('img').filter(function () {
          return normalizeImageUrl($(this).attr('src') || '') === normalizeImageUrl(featuredImage.src);
        }).first();

        if ($navMatch.length) {
          $navMatch.closest('.item').find('a').trigger('click');
        }
      }

      var $targetImg = $sliderFor.find('#product-featured-image-' + featuredImage.id);

      if (!$targetImg.length) {
        $targetImg = $sliderFor.find('.slick-active img[id^="product-featured-image"]');
      }

      if (!$targetImg.length) {
        $targetImg = $sliderFor.find('img[id^="product-featured-image"]').first();
      }

      if ($targetImg.length && window.Shopify && Shopify.Image && Shopify.Image.switchImage) {
        Shopify.Image.switchImage(featuredImage, $targetImg[0], function (newImageSizedSrc) {
          var $fancyLink = $targetImg.closest('a.fancybox');
          if ($fancyLink.length && newImageSizedSrc) {
            $fancyLink.attr('href', newImageSizedSrc.split('?')[0]);
          }
          syncFancyboxHref(newImageSizedSrc || featuredImage.src);
        });
      } else if (featuredImage.src) {
        syncFancyboxHref(featuredImage.src);
      }
    }

    function bindSwatchSelectedLabel() {
      function updateSwatchHeader($swatch, value) {
        if (!$swatch.length || !value) return;
        $swatch.find('[data-swatch-selected-value]').text(value);
      }

      function syncAllSwatchHeaders() {
        $('#add-to-cart-form .swatch').each(function () {
          var $checked = $(this).find('input[type="radio"]:checked');
          if ($checked.length) {
            updateSwatchHeader($(this), $checked.val());
          }
        });
      }

      $(document).on('change', '#add-to-cart-form .swatch input[type="radio"]', function () {
        updateSwatchHeader($(this).closest('.swatch'), $(this).val());
      });

      syncAllSwatchHeaders();
      window.productDetailEnhancements.syncSwatchSelectedLabels = syncAllSwatchHeaders;
    }

    function initCustomizationPanel() {
      var $panel = $('.product-customization-panel');
      if (!$panel.length) return;

      var easifyEl = $panel.find('.easify-product-options')[0];
      var easifyReady = false;
      var easifyObserver = null;
      var panelStateFrame = null;

      function easifyHasContent() {
        if (!easifyEl || !easifyEl.children.length) {
          return false;
        }

        if (easifyEl.querySelector('.tpo_has-option-set, .tpo_open-modal-button, button[class*="tpo_open-modal"]')) {
          return true;
        }

        return !!easifyEl.querySelector('button, input:not([type="hidden"]), select, textarea, [role="button"], label[for]');
      }

      function enhanceEasifyOptions() {
        var panelLabel = $.trim($panel.find('.product-customization-panel__label').first().text()).toLowerCase();

        if (!easifyEl) {
          return;
        }

        Array.prototype.forEach.call(easifyEl.children, function (child) {
          if (!child || child.nodeType !== 1) {
            return;
          }

          child.classList.remove('easify-text-trigger', 'easify-text-trigger--hidden');

          if (child.matches('button, .tpo_open-modal-button, [class*="tpo_open-modal"]')) {
            return;
          }

          if (child.querySelector('button, .tpo_open-modal-button, [class*="tpo_open-modal"]')) {
            child.classList.add('easify-wrapper-reset');
            return;
          }

          var text = $.trim($(child).text());
          var normalized = text.toLowerCase();

          if (text) {
            if (panelLabel && (normalized === panelLabel || normalized.indexOf(panelLabel) === 0 || panelLabel.indexOf(normalized) === 0)) {
              child.classList.add('easify-text-trigger', 'easify-text-trigger--hidden');
              return;
            }

            child.classList.add('easify-text-trigger');
          }
        });
      }

      function bindPrimaryAddToCartBridge() {
        // Main and modal add-to-cart are handled by easify-cart-bridge.js.
      }

      function stopEasifyWatch() {
        if (easifyObserver) {
          easifyObserver.disconnect();
          easifyObserver = null;
        }

        if (panelStateFrame) {
          window.cancelAnimationFrame(panelStateFrame);
          panelStateFrame = null;
        }
      }

      function applyPanelState() {
        if (easifyHasContent()) {
          if (!easifyReady) {
            easifyReady = true;
            stopEasifyWatch();
            $panel.addClass('has-easify').removeClass('no-easify');
            enhanceEasifyOptions();
          }
          return;
        }

        if (!easifyReady) {
          $panel.removeClass('has-easify').addClass('no-easify');
        }
      }

      function schedulePanelState() {
        if (panelStateFrame) {
          window.cancelAnimationFrame(panelStateFrame);
        }

        panelStateFrame = window.requestAnimationFrame(function () {
          panelStateFrame = null;
          applyPanelState();
        });
      }

      applyPanelState();
      bindPrimaryAddToCartBridge();

      if (easifyEl && window.MutationObserver && !easifyReady) {
        easifyObserver = new MutationObserver(schedulePanelState);
        easifyObserver.observe(easifyEl, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden']
        });
      }
    }

    function bindSwatchToVariantImage() {
      $(document).on('change', '#add-to-cart-form .swatch-element--variant-img input[type="radio"]', function () {
        var $radio = $(this);
        var optionIndex = $radio.closest('.swatch').attr('data-option-index');
        var optionValue = $radio.val();
        var $form = $radio.closest('form');
        var $selector = $form.find('.single-option-selector').eq(optionIndex);

        if ($selector.length && $selector.val() !== optionValue) {
          $selector.val(optionValue).trigger('change');
        }
      });
    }

    function initNavThumbZoom() {
      $('.slider-nav .item a[data-zoom-image]').attr('title', 'Double-click to enlarge');

      $(document).on('dblclick', '.slider-nav .item a', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var zoom = $(this).data('zoom-image') || $(this).find('img').attr('src');
        openZoom(zoom);
      });
    }

    function initGalleryFancyboxSync() {
      $(document).on('afterChange', '.slider-for', function (event, slick, currentSlide) {
        if (!slick || typeof currentSlide !== 'number') {
          return;
        }

        var $slide = $(slick.$slides.get(currentSlide));
        var $img = $slide.find('img[id^="product-featured-image"]').first();

        if ($img.length) {
          syncFancyboxHref($img.attr('src') || $img.attr('data-src') || '');
        }
      });
    }

    function initMobileProductLayout() {
      if (window.productDetailMobileLayout && window.productDetailMobileLayout.apply) {
        window.productDetailMobileLayout.apply();
      }
    }

    function initEasifyCartIntegration() {
      if (!document.querySelector('.easify-product-options')) {
        return;
      }

      window.easifyAddToCartEvent = true;
    }

    function openOwnCustomizationModal() {
      var selectors = [
        '.easify-product-options .tpo_open-modal-button',
        '.easify-product-options button[class*="tpo_open-modal"]',
        '.product-customization-panel .tpo_open-modal-button',
        '.product-customization-panel button[class*="tpo_open-modal"]',
        '.easify-product-options .easify-text-trigger:not(.easify-text-trigger--hidden)'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var trigger = document.querySelector(selectors[i]);
        if (trigger) {
          trigger.click();
          return true;
        }
      }

      return false;
    }

    function initStickyCustomEngravingOpen() {
      $(document).off('click.dodoStickyCustom', '.sticky-custom-engraving, [data-open-easify-custom]')
        .on('click.dodoStickyCustom', '.sticky-custom-engraving, [data-open-easify-custom]', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (openOwnCustomizationModal()) {
            return;
          }

          // Easify may still be mounting — retry briefly before falling back.
          var attempts = 0;
          var timer = window.setInterval(function () {
            attempts += 1;
            if (openOwnCustomizationModal() || attempts >= 20) {
              window.clearInterval(timer);
              if (attempts >= 20 && !openOwnCustomizationModal() && window.jQuery && $('#product_custom_engraving').length) {
                $('#product_custom_engraving').modal('show');
              }
            }
          }, 150);
        });
    }

    function initProductDetailAccordion() {
      document.querySelectorAll('.product-detail-description-accordion [data-description-toggle]').forEach(function (link) {
        if (link.dataset.descriptionBound === 'true') {
          return;
        }

        link.dataset.descriptionBound = 'true';

        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var target = document.querySelector(link.getAttribute('data-target'));

          if (!target) {
            return;
          }

          link.classList.toggle('active');
          target.classList.toggle('active');
        });
      });
    }

    function initEngravingModalAddToCartButton() {
      var scopeSelector = '#product_custom_engraving, .tpo_modal-container';

      function isIgnoredControl(el) {
        return !el ||
          el.classList.contains('close') ||
          el.classList.contains('tpo_close-popup-button') ||
          el.classList.contains('tpo_modal-close-btn') ||
          el.closest('.modal-header');
      }

      function isAddToCartControl(el) {
        if (isIgnoredControl(el) || el.classList.contains('engraving-modal-add-to-cart')) {
          return false;
        }

        if (el.classList.contains('add_customize') || el.classList.contains('tpo_add-to-cart') || el.classList.contains('tpo_edit-option_confirm-button')) {
          return true;
        }

        var text = ((el.textContent || el.value || el.getAttribute('aria-label') || '') + '').trim().toLowerCase();
        return text.indexOf('add to cart') !== -1;
      }

      function enhanceButton(el) {
        if (!isAddToCartControl(el)) {
          return;
        }

        el.classList.add('engraving-modal-add-to-cart');

        if (el.closest('#product_custom_engraving') && !el.closest('.engraving-modal-cta-bar')) {
          var bar = document.createElement('div');
          bar.className = 'engraving-modal-cta-bar';
          el.parentNode.insertBefore(bar, el);
          bar.appendChild(el);
        }
      }

      function scanScope(scope) {
        if (!scope) {
          return;
        }

        scope.querySelectorAll('.tpo_add-to-cart, .tpo_edit-option_confirm-button, .add_customize, button, input[type="submit"], input[type="button"], a').forEach(enhanceButton);
      }

      function scanAll() {
        document.querySelectorAll(scopeSelector).forEach(scanScope);
      }

      function pollAfterOpen() {
        var attempts = 0;
        var timer = window.setInterval(function () {
          scanAll();
          attempts += 1;
          if (attempts >= 25) {
            window.clearInterval(timer);
          }
        }, 200);
      }

      scanAll();

      if (window.MutationObserver) {
        new MutationObserver(scanAll).observe(document.body, { childList: true, subtree: true });
      }

      $(document).on('shown.bs.modal', '#product_custom_engraving', pollAfterOpen);
      $(document).on('click', '#product-add-to-cart, .tpo_open-modal-button, .btn-customize', pollAfterOpen);
    }

    $(document).ready(function () {
      window.productDetailEnhancements = {
        openZoom: openZoom,
        syncFancyboxHref: syncFancyboxHref,
        syncVariantMainImage: syncVariantMainImage
      };

      initNavThumbZoom();
      initGalleryFancyboxSync();
      bindSwatchSelectedLabel();
      bindSwatchToVariantImage();
      initMobileProductLayout();
      initEasifyCartIntegration();
      initStickyCustomEngravingOpen();
      initProductDetailAccordion();
      initEngravingModalAddToCartButton();
    });

    initCustomizationPanel();

    document.addEventListener('shopify:section:load', initProductDetailAccordion);
  })(window.jQuery);
})();
